<template>
  <div>
    <div
      class="mt-3 main-theme bg-white-border p-3"
      v-if="useSlaFromChannelSetting"
    >
      <p class="my-2 dropdown-date-custom-text label-checkbox">Select Brand</p>
      <b-row class="pt-2">
        <b-col cols="4">
          <InputSelect
            :class="isDetail ? 'cursor-default' : ''"
            title="แบรนด์"
            name="brand"
            isRequired
            v-model="form.platformConfigId"
            :options="platformIdList"
            valueField="id"
            textField="name"
            :disabled="isDetail"
            @onDataChange="(val) => (form.platformConfigId = val)"
            :isValidate="v.form.platformConfigId.$error"
            :v="v.form.platformConfigId"
          />
          <div class="text-error-wrp" v-if="v.form.platformConfigId.$error">
            <span class="text-error" v-if="!v.form.platformConfigId.notSelect99"
              >Select Brand</span
            >
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <p class="my-2 dropdown-date-custom-text label-checkbox">
        Target First Response Time
      </p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox
            class="mt-1"
            v-model="form.waitDueIsEnable"
            :value="1"
            :unchecked-value="0"
          >
            Enable
          </b-form-checkbox></b-col
        >
      </b-row>
      <div v-if="!!form.waitDueIsEnable">
        <b-row class="pt-2">
          <b-col cols="3">
            <InputNumber
              v-model="form.waitDueMinute"
              textFloat="Minutes"
              placeholder="Minutes"
              type="number"
              :value="form.waitDueMinute"
              :isRequired="!!form.waitDueIsEnable"
              :isValidate="v.form.waitDueMinute.$error"
              :v="v.form.waitDueMinute"
            />
          </b-col>
          <p class="d-flex mt-4 align-items-center justify-content-start">
            Minutes
          </p>
        </b-row>
        <b-row>
          <b-col cols="4">
            <ColorPicker
              textFloat="If Over Color"
              v-model="form.waitDueColor"
              :value="form.waitDueColor"
              name="overColor"
              :isRequired="!!form.waitDueIsEnable"
              :isValidate="v.form.waitDueColor.$error"
              :v="v.form.waitDueColor"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-checkbox
              class="mt-1"
              v-model="form.waitDueIsSendMessage"
              :value="1"
              :unchecked-value="0"
            >
              Send Message
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <InputTextArea
              v-model="form.waitDueMessage"
              type="text"
              placeholder="WaitDueMessage"
              name="text"
              rows="5"
              :isRequired="!!form.waitDueIsSendMessage"
              :isValidate="v.form.waitDueMessage.$error"
              :v="v.form.waitDueMessage"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-checkbox
              class="mt-1"
              v-model="form.waitNotifyAdmin"
              :value="1"
              :unchecked-value="0"
            >
              Notify Team Admin
            </b-form-checkbox></b-col
          >
        </b-row>
      </div>
      <hr />
      <b-row>
        <b-col cols="12">
          <p class="my-2 dropdown-date-custom-text label-checkbox">
            Target Every Response Time
          </p>
        </b-col>
        <b-col cols="12">
          <b-form-checkbox
            class="mt-1"
            v-model="form.resolutionDueIsEnable"
            :value="1"
            :unchecked-value="0"
          >
            Enable
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div v-if="!!form.resolutionDueIsEnable">
        <b-row class="pt-2">
          <b-col cols="3">
            <InputNumber
              v-model="form.resolutionDueMinute"
              textFloat="Minutes"
              placeholder="Minutes"
              type="number"
              :value="form.resolutionDueMinute"
              :isRequired="!!form.resolutionDueIsEnable"
              :isValidate="v.form.resolutionDueMinute.$error"
              :v="v.form.resolutionDueMinute"
            />
          </b-col>
          <p class="d-flex align-items-center mt-4 justify-content-start">
            Minutes
          </p>
        </b-row>
        <b-row>
          <b-col cols="4">
            <ColorPicker
              textFloat="Color"
              v-model="form.resolutionDueColor"
              :value="form.resolutionDueColor"
              :isRequired="!!form.resolutionDueIsEnable"
              :isValidate="v.form.resolutionDueColor.$error"
              :v="v.form.resolutionDueColor"
              name="color"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-checkbox
              class="mt-1"
              v-model="form.resolutionDueIsSendMessage"
              :value="1"
              :unchecked-value="0"
            >
              Send Message
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <InputTextArea
              v-model="form.resolutionDueMessage"
              type="text"
              placeholder="ResolutionDueMessage"
              name="text"
              rows="5"
              :isRequired="!!form.resolutionDueIsSendMessage"
              :isValidate="v.form.resolutionDueMessage.$error"
              :v="v.form.resolutionDueMessage"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-checkbox
              class="mt-1"
              v-model="form.resolutionNotifyAdmin"
              :value="1"
              :unchecked-value="0"
            >
              Notify Agent
            </b-form-checkbox></b-col
          >
        </b-row>
      </div>
      <hr />
      <b-row>
        <b-col cols="12">
          <p class="my-2 dropdown-date-custom-text label-checkbox">
            Target Resolution Time
          </p>
        </b-col>
        <b-col cols="12">
          <b-form-checkbox
            class="mt-1"
            v-model="form.resolutionTimeEnable"
            :value="1"
            :unchecked-value="0"
          >
            Enable
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div v-if="!!form.resolutionTimeEnable">
        <b-row class="pt-2">
          <b-col cols="3">
            <InputNumber
              v-model="form.resolutionTimeMinute"
              textFloat="Minutes"
              placeholder="Minutes"
              type="number"
              :value="form.resolutionTimeMinute"
              :isRequired="!!form.resolutionDueIsEnable"
              :isValidate="v.form.resolutionTimeMinute.$error"
              :v="v.form.resolutionTimeMinute"
            />
          </b-col>
          <p class="d-flex align-items-center mt-4 justify-content-start">
            Minutes
          </p>
        </b-row>
      </div>
      <div v-if="useSlaFromChannelSetting">
        <hr />
        <b-row>
          <b-col cols="12">
            <p class="my-2 dropdown-date-custom-text label-checkbox">
              After Business Hours
            </p>
          </b-col>
          <b-col cols="12">
            <b-form-checkbox
              class="mt-1"
              v-model="form.channelBusinessHourEnable"
              :value="1"
              :unchecked-value="0"
            >
              Enable
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div v-if="!!form.channelBusinessHourEnable">
          <!-- <b-row class="pt-2">
            <b-col cols="3">
              <InputNumber
                v-model="form.nonBusinessTime"
                textFloat="Minutes"
                placeholder="Minutes"
                type="number"
                :value="form.nonBusinessTime"
                :isRequired="!!form.channelBusinessHourEnable"
                :isValidate="v.form.nonBusinessTime.$error"
                :v="v.form.nonBusinessTime"
              />
            </b-col>
            <p class="d-flex align-items-center mt-4 justify-content-start">
              Minutes
            </p>
          </b-row> -->
          <b-row>
            <b-col cols="4">
              <ColorPicker
                textFloat="Color"
                v-model="form.nonBusinessColor"
                :value="form.nonBusinessColor"
                :isRequired="!!form.channelBusinessHourEnable"
                :isValidate="v.form.nonBusinessColor.$error"
                :v="v.form.nonBusinessColor"
                name="color"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-checkbox
                class="mt-1"
                v-model="form.nonBusinessIsSendMessage"
                :value="1"
                :unchecked-value="0"
              >
                Send Message
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <InputTextArea
                v-model="form.nonBusinessMessage"
                type="text"
                placeholder="NonBusinessMessage"
                name="text"
                rows="5"
                :isRequired="!!form.nonBusinessIsSendMessage"
                :isValidate="v.form.nonBusinessMessage.$error"
                :v="v.form.nonBusinessMessage"
              />
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="mt-4">
        <b-col md="12" class="text-sm-right">
          <button
            type="button"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
            @click="hadleClickSave"
            :disabled="loading"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import InputNumber from "@/components/inputs/InputNumber";
import ColorPicker from "@/components/inputs/InputColorPicker";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";

export default {
  name: "SlaPolicyForm",
  components: {
    InputNumber,
    ColorPicker,
    InputTextArea,
    InputSelect,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      required: true,
    },
    platformIdList: {
      type: Array,
      required: true,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      useSlaFromChannelSetting:
        this.$store.getters.getBrandList()[0]?.useSlaFromChannelSetting,
    };
  },
  methods: {
    hadleClickSave() {
      this.$emit("save");
    },
  },
};
</script>

<style lang="scss" scoped>
.label-checkbox {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}

.text-error-wrp {
  position: absolute !important;
  bottom: -6px;
}

::v-deep .cursor-default {
  .btn-select {
    cursor: default !important;
  }
}
</style>
